@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  html {
    scroll-behavior: smooth;
    /* Offset fixed header height so anchor links don't hide content behind nav */
    scroll-padding-top: 4rem;
  }

  /* Smooth color transitions when toggling dark/light mode */
  *,
  *::before,
  *::after {
    transition-property: background-color, border-color, color, fill, stroke;
    transition-duration: 200ms;
    transition-timing-function: ease;
  }

  /* Reset transition for elements that need their own animation control */
  [data-framer-motion],
  .no-transition {
    transition: none !important;
  }
}
